<!-- 库房单元 -->
<template>
	<WmsReport :ref="wmsReport" type="MDPDJL" :tableHead="tableHead" :reportConditionVos="reportConditionVos">
	</WmsReport>
</template>

<script>
import WmsReport from '@/components/wmsReport.vue';

export default {
	components: { WmsReport },

	data() {
		var _this = this
		//这里存放数据
		return {
			reportConditionVos: [
				{ fieldShow: "开始日期", fieldEntity: "SRQ" },
				{ fieldShow: "结束日期", fieldEntity: "ERQ" },
				{ fieldShow: "门店名称", fieldEntity: "MDNAME" },
				{ fieldShow: "通用名称", fieldEntity: "SPMCH" },
				{ fieldShow: "批号", fieldEntity: "PIHAO" },

			],//搜索内容，
			tableHead: [
				"盘点日期",
				"单据编号",
				"门店名称",
				"商品编号",
				"通用名称",
				"规格",
				"生产厂商",
				"产地",
				"数量",
				"单位",
				"实盘数量",
				"差异数量",
				"差异金额",
				"批号",
				"生产日期",
				"有效期至",
				"批准文号",
				"类别",
				"剂型",
				"上市许可持有人",
				"存储条件"
			],//默认表头，当拿到数据时，表头从数据第一条内容的获取
		};
	},
	mounted() {

	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {


	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {

	},

	beforeCreate() {

	}, //生命周期 - 创建之前
	beforeMount() {

	}, //生命周期 - 挂载之前
	beforeUpdate() {
	}, //生命周期 - 更新之前
	updated() {
	}, //生命周期 - 更新之后
	beforeDestroy() {

	}, //生命周期 - 销毁之前
	destroyed() {
	}, //生命周期 - 销毁完成
	activated() {
	},
}
</script>
<style></style>
